import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActiveWidget } from '../../classes/active-widget';
import { WidgetModel } from '../../models/widget.model';
import { CustomWidgetInterface } from '../../interfaces/custom-widget.interface';
import { LoaderInstance } from '../../../support/loading/loader.service';

@Component({
    selector: 'chassis-core-custom-widget',
    templateUrl: './custom-widget.component.html',
    styleUrls: ['./custom-widget.component.scss']
})
export class CustomWidgetComponent implements OnInit {

    @Input() public widget: WidgetModel;

    /**
     * Event that will be emitted when the widget should refresh
     */
    @Output() resetEvent = new EventEmitter();

    /**
     * @type {ListWidgetOptions}
     */
    @Input() public options: CustomWidgetInterface;

    /**
     * The LoaderInstance instance
     *
     * @type {LoaderInstance}
     */
    @Input() public loader: LoaderInstance;

    constructor(public widgetRef: ActiveWidget) {
    }

    ngOnInit() {

    }

    /**
     * Refresh the widget
     *
     * @returns {void}
     */
    public refresh() {
        this.widgetRef.refresh();
        this.resetEvent.emit();
    }

    /**
     * Remove the widget
     *
     * @returns {void}
     */
    public remove() {
        this.widgetRef.remove();
    }

    /**
     * Indicates if the widget is loading
     *
     * @returns {void}
     */
    public get loading() {
        return this.loader ? this.loader.isLoading() : false;
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/components/custom-widget/custom-widget.component.ts